import React from 'react';
import { motion } from 'framer-motion';
import VerticalTimeline from './VerticalTimeline';

const Timeline = () => {
  return (
    <section className="prose prose-invert max-w-none">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-2xl font-bold mb-6">Animatronics History Highlights</h2>
        <p className="text-lg leading-relaxed mb-12">
          Disney continued to lead the charge in animatronic innovation through the decades that followed the opening of Disneyland. Disney's success inspired compeition and the adoption of animatronics and themed environments across new media.  Universal began development of a new park in Florida to follow up on the success of Universal Hollywood. Nolan Bushnell was inspired by Disneyland when he created the concept for his restaurant: Chuck E. Cheese.
        </p>

        <div className="card bg-background-secondary p-6">
          <VerticalTimeline />
        </div>
      </motion.div>
    </section>
  );
}

export default Timeline;